import styled from 'styled-components';
import * as antd from 'antd';
import * as common from '../../_common';

export const BaseForm = styled(common.BaseForm)`
 display: flex;
 flex-direction: column;
 flex-wrap: wrap;
 justify-content: center;
 padding: 40px 30px;

 @media (min-width: 1160px) {
  flex-direction: row;
  justify-content: flex-start;
  padding-bottom: 0;
 }

 .ant-btn-primary:hover,
 .ant-btn-primary:active,
 .ant-btn-primary:focus {
  background:
   linear-gradient(#ffeec7, #ffeec7) padding-box,
   linear-gradient(
     42.69deg,
     #fff33b -5.54%,
     #fee72e -1.35%,
     #fed51b 6.72%,
     #fdca10 15%,
     #fdc70c 23.9%,
     #f3903f 64.56%,
     #ed683c 87.51%,
     #e93e3a 99.24%
    )
    border-box;
 }
`;

export const Col = styled.div<{ flex?: number }>`
 flex: ${(props) => props.flex ?? 1};
 margin: 0 2%;
 padding-top: 20px;

 &:first-child {
  padding-top: 0;
 }

 @media (min-width: 1160px) {
  padding-top: 0;
 }
`;

export const SubmitButton = styled((props) => (
 <antd.Button {...props} type="primary" size="large" />
))`
 background:
  linear-gradient(#fff, #fff) padding-box,
  linear-gradient(
    42.69deg,
    #fff33b -5.54%,
    #fee72e -1.35%,
    #fed51b 6.72%,
    #fdca10 15%,
    #fdc70c 23.9%,
    #f3903f 64.56%,
    #ed683c 87.51%,
    #e93e3a 99.24%
   )
   border-box;
 color: #313149;
 margin-top: 30px;
 width: 100%;
 font-size: 18px;
 line-height: 18px;
`;

export const ShowButton = styled((props) => (
 <antd.Button {...props} type="primary" size="large" />
))`
 background:
  linear-gradient(#fff, #fff) padding-box,
  linear-gradient(
    42.69deg,
    #fff33b -5.54%,
    #fee72e -1.35%,
    #fed51b 6.72%,
    #fdca10 15%,
    #fdc70c 23.9%,
    #f3903f 64.56%,
    #ed683c 87.51%,
    #e93e3a 99.24%
   )
   border-box;
 color: #313149;
 margin-top: -5px;
 margin-left: 20px;
 width: 100%;
 font-size: 18px;
 line-height: 18px;
`;

export const Modal = styled(antd.Modal)`
 .ant-modal-content {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
 }
 .ant-modal-footer {
  text-align: center;
  border: none;
 }
 .ant-modal-body {
  padding: 20px 20px 0 20px;
 }
`;

export const ButtonCancel = styled(antd.Button)`
 margin: auto;
 width: 150px;
 font-size: 18px;
 line-height: 18px;
 color: #2b314f;
`;
